import {RewardsState} from '../../reducers/fortnite-game/rewards.reducer';

export const getRewardsState = (state): RewardsState => {
    return state.get('rewards').toJS();
};
